import React, { createContext } from 'react';
import isNil from 'lodash/isNil';

import Loader from '../components/Loader/Loader';

export interface ContextType {
  isLoading: boolean;
  props: any;
  toggleLoading: (isLoading?: boolean) => void;
}

const LoaderContext = createContext<ContextType>({
  isLoading: false,
  props: {},
  toggleLoading: () => {},
});

const LoaderConsumer = LoaderContext.Consumer;

const withLoaderContext = Component => props => (
  <LoaderConsumer>{({ toggleLoading }) => <Component {...props} toggleLoading={toggleLoading} />}</LoaderConsumer>
);

const LoaderRoot = () => (
  <LoaderConsumer>{({ isLoading }) => <Loader isLoading={isLoading} type="overlay" />}</LoaderConsumer>
);

class LoaderProvider extends React.Component<any, ContextType> {
  constructor(props) {
    super(props);

    this.toggleLoading = this.toggleLoading.bind(this);

    this.state = {
      isLoading: false,
      props: {},
      toggleLoading: this.toggleLoading,
    };
  }

  toggleLoading(isLoading) {
    if (isNil(isLoading)) {
      this.setState(prevState => ({
        isLoading: !prevState.isLoading,
      }));
    } else {
      this.setState({ isLoading });
    }
  }

  render() {
    return (
      <LoaderContext.Provider value={this.state}>
        <LoaderRoot />
        {this.props.children}
      </LoaderContext.Provider>
    );
  }
}

export { LoaderContext, LoaderConsumer, withLoaderContext, LoaderRoot, LoaderProvider };
